module.exports = __webpack_public_path__ + "static/media/IMG_4273.a704c67d.PNG";